<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-13 11:24:47
 * @LastEditTime: 2023-02-08 09:01:48
 * @Description:
 * @FilePath: \com.tudouec.manager.pm.vue.v1d:\codeLibraty\金豆\中国薯网官网\web\website\src\components\LoadMore.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="load-more">
    <div class="text" :style="`color:${color}`" @click="navTo()">查看更多</div>
    <div
      class="arrow"
      :style="{'background-color': arrowColor}"
      @click="navTo()"
    >
      <i :class="`el-icon-${arrow}`" :style="{'color': arrowColor =='#FFF' ? '#019845' : '#FFF'}"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoadMore",
  props: {
    color: { type: String, default: "#686B82" },
    arrow: { type: String, default: "right" },
    arrowColor: { type: String, default: "#019845" },
    pagename: { type: String, default: "" },
  },
  data() {
    return {};
  },
  methods: {
    navTo() {
      let url = this.pagename;
      if (url === "") return;
      this.$router.push({ name: url });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.load-more {
  display: flex;
  cursor: pointer;
  .arrow {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    margin-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadMore.vue